<template>
    <v-container fluid class="pa-4">
        <v-card>
            <v-card-title class="d-flex justify-space-between align-center">
                <span class="title">{{ $t('navmenuAdmin.klijenti') }}</span>
                <div class="d-flex">
                    <v-tooltip location="bottom" content-class="custom-tooltip">
                        <template #activator="{ props }">
                            <v-btn v-bind="props" size="small" variant="outlined" color="primary" class="action-btn"
                                icon="mdi-plus" @click="openAdd" />
                        </template>
                        {{ $t('navmenuAdmin.dodajKlijenta') }}
                    </v-tooltip>
                </div>
            </v-card-title>

            <v-card-text>
                <v-data-table :headers="headers" :items="companies" :loading="loading" class="custom-header"
                    :items-per-page="15">

                    <template v-slot:headers="{ columns, toggleSort, isSorted, getSortIcon }">
                        <tr>
                            <th v-for="column in columns" :key="column.value"
                                @click="() => column.sortable && toggleSort(column)"
                                :style="{ cursor: column.sortable ? 'pointer' : 'default', width: column.width }"
                                class="sortable-header">
                                <div class="d-flex align-center justify-space-between">
                                    <strong>{{ column.text }}</strong>
                                    <v-icon v-if="column.sortable" size="12" class="sort-icon ml-2"
                                        :class="{ active: isSorted(column) }">
                                        {{ isSorted(column) ? getSortIcon(column) : 'mdi-arrow-up-down' }}
                                    </v-icon>
                                </div>
                            </th>
                        </tr>
                    </template>

                    <template v-slot:item="{ item }">
                        <tr>
                            <td>{{ item.Name }}</td>
                            <td>{{ item.Shorts || '-' }}</td>
                            <td>{{ item.CountryName || '-' }}</td>
                            <td>
                                <v-btn variant="text" class="status-btn" @click="toggleStatus(item)">
                                    <img v-if="item.Valid" :src="statusImages.aktivan" height="22" />
                                    <img v-if="!item.Valid" :src="statusImages.neaktivan" height="22" />
                                </v-btn>
                            </td>
                            <td class="text-right">
                                <div class="d-flex justify-end ga-2">
                                    <v-tooltip location="bottom" content-class="custom-tooltip">
                                        <template #activator="{ props }">
                                            <v-btn v-bind="props" size="small" variant="outlined" color="success"
                                                class="action-btn" @click="selectClient(item)">
                                                <v-icon size="16">mdi-check</v-icon>
                                            </v-btn>
                                        </template>
                                        {{ $t('navmenuAdmin.odaberi') }}
                                    </v-tooltip>

                                    <v-tooltip location="bottom" content-class="custom-tooltip">
                                        <template #activator="{ props }">
                                            <v-btn v-bind="props" size="small" variant="outlined" color="primary"
                                                class="action-btn" @click="openEdit(item)">
                                                <v-icon size="16">mdi-pencil</v-icon>
                                            </v-btn>
                                        </template>
                                        {{ $t('general.uredi') }}
                                    </v-tooltip>

                                </div>
                            </td>
                        </tr>
                    </template>

                </v-data-table>
            </v-card-text>
        </v-card>

        <!-- MODAL ADD/EDIT -->
        <BaseModal v-model="dialog"
            :title="editMode ? $t('navmenuAdmin.urediKlijentaUPPER') : $t('navmenuAdmin.dodajKlijentaUPPER')" size="md">
            <v-form ref="form" v-model="isFormValid">
                <v-row dense>
                    <v-col cols="12">
                        <v-text-field v-model="form.Name" :label="$t('navmenuAdmin.nazivFirme')"
                            :rules="[rules.required]" density="comfortable" class="my-text" autocomplete="off" />
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="form.Shorts" :label="$t('navmenuAdmin.skracenica')" density="comfortable"
                            class="my-text" autocomplete="off" />
                    </v-col>
                    <v-col cols="12" v-if="!editMode">
                        <v-select v-model="form.CountryId" :items="countries" item-title="CountryName"
                            item-value="CountryId" :label="$t('navmenuAdmin.zemlja')" :rules="[rules.required]"
                            density="comfortable" class="my-select" />
                    </v-col>
                    <v-col cols="12">
                        <v-file-input v-model="headerFile" :label="$t('navmenuAdmin.headerSlika')" accept="image/*"
                            prepend-icon="mdi-image" density="comfortable" class="my-text" clearable />
                    </v-col>
                </v-row>
            </v-form>

            <template #footer>
                <div class="d-flex justify-end ga-2">
                    <v-btn variant="outlined" @click="dialog = false">
                        <span style="font-size:14px; font-weight:600;">{{ $t('general.cancel') }}</span>
                    </v-btn>
                    <v-btn color="primary" variant="flat" @click="save">
                        <span style="font-size:14px; font-weight:600;">{{ $t('general.save') }}</span>
                    </v-btn>
                </div>
            </template>
        </BaseModal>

    </v-container>
</template>

<script>
import BaseModal from '@/components/dialogs/BaseModal.vue'

export default {
    name: 'SuperAdminClients',
    components: { BaseModal },
    data() {
        return {
            loading: false,
            companies: [],
            countries: [],
            dialog: false,
            editMode: false,
            isFormValid: false,
            form: { Id: null, Name: '', Shorts: '', CountryId: null },
            rules: {
                required: v => (v !== null && v !== undefined && v !== '') || this.$t('systemMessage.m1'),
            }
        }
    },
    computed: {
        headers() {
            return [
                { text: this.$t('navmenuAdmin.nazivFirme'), value: 'Name', sortable: true, width: 'calc(48.5% - 110px)' },
                { text: this.$t('navmenuAdmin.skracenica'), value: 'Shorts', sortable: true, width: '15%' },
                { text: this.$t('navmenuAdmin.zemlja'), value: 'CountryName', sortable: true, width: '26%' },
                { text: this.$t('general.status'), value: 'Valid', sortable: false, width: '10.5%' },
                { text: this.$t('general.options'), value: 'actions', sortable: false, width: '110px' },
            ]
        },
        imageLang() {
            const lang = localStorage.getItem('lang')
            if (lang === 'sr' || lang === 'cir-ekavica') return 'Cir'
            if (lang === 'en') return 'Eng'
            return 'Lat'
        },
        statusImages() {
            const lang = this.imageLang
            return {
                aktivan: `/img/aktivan${lang}.png`,
                neaktivan: `/img/neaktivan${lang}.png`,
            }
        }
    },
    async mounted() {
        await this.fetchCompanies()
        const lang = localStorage.getItem('lang')
        const isCyrillic = lang === 'sr' || lang === 'cir-ekavica'

        const r = await this.$axios.get('Country/Show', { params: { languageId: isCyrillic ? 1 : 2 } })

        this.countries = r.data.map(c => ({
            CountryId: c.Id,
            CountryName: c.Name
        }))
    },
    methods: {
        selectClient(item) {
            localStorage.setItem('CompanyId', item.Id)
            localStorage.setItem('CompanyHeader', item.Header || '')
            this.$router.go(0)
        },
        async fetchCompanies() {
            this.loading = true
            try {
                const lang = localStorage.getItem('lang')
                const isCyrillic = lang === 'sr' || lang === 'cir-ekavica'

                const r = await this.$axios.get('SuperAdmin', {
                    params: {
                        languageId: isCyrillic ? 1 : 2
                    }
                })
                this.companies = r.data || []
            } catch (err) {
                console.error(err)
            } finally {
                this.loading = false
            }
        },
        async fetchCountries() {
            try {
                const r = await this.$axios.get('SuperAdmin/Countries')
                this.countries = r.data || []
            } catch (err) {
                console.error(err)
            }
        },
        openAdd() {
            this.editMode = false
            this.headerFile = null
            this.form = { Id: null, Name: '', Shorts: '', CountryId: null, Header: null }
            this.dialog = true
            this.$nextTick(() => this.$refs.form?.resetValidation())
        },
        openEdit(item) {
            this.editMode = true
            this.headerFile = null
            this.form = { Id: item.Id, Name: item.Name, Shorts: item.Shorts, CountryId: item.CountryId, Header: item.Header }
            this.dialog = true
            this.$nextTick(() => this.$refs.form?.resetValidation())
        },
        async toggleStatus(item) {
            try {
                await this.$axios.put('SuperAdmin/Company/Aktivacija', null, { params: { id: item.Id } })
                item.Valid = !item.Valid
                this.$store.dispatch('NOTIF_SUCCESS', {
                    poruka: this.$t('User_message.m135'),
                    position: 'top-end',
                    timer: 2500,
                    action: 'noreload'
                })
            } catch (err) {
                console.error(err)
            }
        },
        async save() {
            const { valid } = await this.$refs.form.validate()
            if (!valid) return
            // Upload slike ako je odabrana
            if (this.headerFile) {
                const ext = this.headerFile.name.split('.').pop()
                const fileName = `Header_${Date.now()}.${ext}`
                const file = new File([this.headerFile], fileName, { type: this.headerFile.type })
                const formData = new FormData()
                formData.append('file', file)
                await this.$axios.post('Upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
                this.form.Header = fileName
            }

            try {
                if (this.editMode) {
                    await this.$axios.put('SuperAdmin/Company/Edit', {
                        Id: this.form.Id,
                        Name: this.form.Name,
                        Shorts: this.form.Shorts,
                        CountryId: this.form.CountryId,
                        Header: this.form.Header,
                    })

                    this.$store.dispatch('NOTIF_SUCCESS', {
                        poruka: this.$t('User_message.m134'),
                        position: 'top-end',
                        timer: 2500,
                        action: 'noreload'
                    })

                    this.dialog = false
                    await this.fetchCompanies()

                } else {
                    await this.$axios.post('SuperAdmin/Company/Add', {
                        Id: 0,
                        Name: this.form.Name,
                        Shorts: this.form.Shorts,
                        CountryId: this.form.CountryId,
                        Valid: true,
                        Header: this.form.Header
                    })

                    this.$store.dispatch('NOTIF_SUCCESS', {
                        poruka: this.$t('User_message.m133'),
                        position: 'top-end',
                        timer: 2500,
                        action: 'noreload'
                    })

                    this.dialog = false
                    this.$router.go(0)
                }

            } catch (err) {
                this.$store.dispatch('NOTIF_WARNING', {
                    poruka: this.$t('User_message.m136'),
                    position: 'center',
                    icon: 'error',
                    timer: 4500,
                    width: '550'
                })
            }
        }
    }
}
</script>